
import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const EffectsContext = createContext({
    effects: [],
    loading: true,
    refresh: () => { }
});

export const useEffectsData = () => useContext(EffectsContext);

export const EffectsProvider = ({ children }) => {
    const [effects, setEffects] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadData = async () => {
        setLoading(true);
        try {
            const result = await pb.collection('site_seasonal_effects').getList(1, 50, { sort: '-created' });
            setEffects(result.items || []);
        } catch (err) {
            console.error("Error loading seasonal effects:", err);
            // Don't fail hard, just empty list
            setEffects([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <EffectsContext.Provider value={{ effects, loading, refresh: loadData }}>
            {children}
        </EffectsContext.Provider>
    );
};
